const ModalTransactionSuccessfully = () => {
    return (
        <div className="trans-updates">
            <img src="/img/payments/payment-successful.svg" alt=""/>
            <span className="f-medium f-20 block m-lg-t">Your transaction has been successfully completed.</span>
        </div>
    );
};

export default ModalTransactionSuccessfully;
